function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5909 68.6213L33 68.368L32.4092 68.6213L1.83337 81.7252V9.33333C1.83337 5.02843 5.3618 1.5 9.66671 1.5H56.3334C60.6383 1.5 64.1667 5.02843 64.1667 9.33333V81.7252L33.5909 68.6213Z",
  stroke: "currentColor",
  strokeWidth: 3
});
function SvgWatchlistThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 84,
    viewBox: "0 0 66 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchlistThin);
export default __webpack_public_path__ + "static/media/watchlist-thin.fe6a88a9.svg";
export { ForwardRef as ReactComponent };